import { pino } from 'pino';

export const logger = pino({
    level: 'info',
    depthLimit: 2,
    base: undefined,
});
